import { useEffect, useRef, useState } from 'react'
import './list.scss'
import './loading.scss'
import EventBus from '../../utils/EventBus';
import util from '../../utils/util';
import Block from '../../components/Base/Block';
import View from '../../components/Base/View';
import Image from '../../components/Base/Image';
import Text from '../../components/Base/Text';
import tool from '../../utils/addressUtil';
import { Spin } from 'antd';
import rm from '../../utils/rm';
import addressManager from '../../manager/address';

const AddressList = () => {

    const [fromCheckout, setFromCheckout] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [list, setList] = useState<{
        Addresses: any[],
        DefaultAddressId: number
    }>();

    useEffect(() => {
        document.title = "我的收货地址";
        const urlInfo = util.parasUrl(window.location.href);
        if ((urlInfo.params as any).fromcheckout) {
            setFromCheckout(true)
        }

        document.title = (urlInfo.params as any).fromcheckout ? '请选择收货地址' : '收货地址管理';

        const onGetAddressList = function (result: any) {
            setLoading(false)
            if (result.success) {
                setList(result.res.data.Content)
            }
        };

        EventBus.register(EventBus.names.ADDRESS_LIST_GET, onGetAddressList)
        addressManager.getAddressList()
        return () => {
            EventBus.unregister(EventBus.names.ADDRESS_LIST_GET, onGetAddressList)
        }
    }, [])

    const addAddress = () => {
        util.navigateTo('/address/edit?isrmmp=1&hidemenu=1')
    }

    return list?.Addresses && list.Addresses.length > 0 ? (
        <Block>
            <View className={'address-list '}>
                {list.Addresses.map((item, index) => {
                    return (
                        <View
                            className="flex-conainer address-list-item"
                            data-index={index}
                            onClick={() => {
                                if (fromCheckout) {
                                    var selectedAddressInfo = list.Addresses[index]
                                    EventBus.send(EventBus.names.ADDRESS_SELECTED, selectedAddressInfo, true)
                                    rm.closeWindow();
                                }
                            }}
                        >
                            <Image
                                className="product-select flex-fixed"
                                src={
                                    require('../../images/cart-' +
                                        (item.Id === list.DefaultAddressId
                                            ? 'select'
                                            : 'unselect') +
                                        '.png')
                                }
                            ></Image>
                            <View className="flex-conainer flex-grow flex-shrink address-list-item-meta">
                                <View className="address-user">
                                    <Text className="address-name">{item.Name}</Text>
                                    <Text>{tool.getDisplayPhoneNumber(item.PhoneNumber)}</Text>
                                    {item.Id === list.DefaultAddressId && (
                                        <Text className="default-icon">默认</Text>
                                    )}
                                    {!tool.isEmpty(item.AliasName) && (
                                        <Text className="aliasname-icon">{item.AliasName}</Text>
                                    )}
                                </View>
                                <Text className="address-detail">
                                    {tool.getFullAddress(item)}
                                </Text>
                            </View>
                            <Image
                                className="write-btn flex-fix"
                                src={require('../../images/tab-write-btn.png')}
                                data-id={item.Id}
                                onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    util.navigateTo('/address/edit?isrmmp=1&hidemenu=1&id=' + item.Id)
                                }}
                            ></Image>
                        </View>
                    )
                })}
            </View>
            <View className={'address-btns padding-safe-area'}>
                {/* <View
            className="address-btn import-wx-btn"
            onClick={this.importWxAddress}
          >
            导入微信地址
          </View> */}
                <View className="address-btn save-btn" onClick={addAddress}>
                    新增收货地址
                </View>
            </View>
        </Block>
    ) : loading ? (
        <div style={{
            width:"100%",
            height:"100vh",
            display:"flex",
            alignItems:"center",
            justifyContent:"center"
        }}>
            <Spin
            
            />
        </div>
    ) : (
        <View className="load-tip-empty">
            <Image
                className="load-tip-cart"
                src={require('../../images/empty-address.png')}
            ></Image>
            <Text className="empty-tip-text">还没有收货地址，快去添加吧！</Text>
            {/* <View
          className="address-btn import-wx-btn"
          onClick={this.importWxAddress}
        >
          导入微信地址
        </View> */}
            <View className="address-btn save-btn" onClick={addAddress}>
                添加收货地址
            </View>
        </View>
    )
}

export default AddressList